jQuery( document ).ready( function( $ ) {

    // Count textarea characters
    $( '.custom-textarea textarea' ).keyup( function() {
        $( this ).parents( '.custom-textarea' ).find( '.counter' ).html( $( this ).val().length + '/' + $( this ).attr( 'maxlength' ) );
    });

    $( '.custom-textarea textarea' ).focus( function() {
        $( this ).parents( '.custom-textarea' ).addClass( 'focus' );
    });

    $( '.custom-textarea textarea' ).focusout( function() {
        $( this ).parents( '.custom-textarea' ).removeClass( 'focus' );
    });

});